import { Box, Container } from "@mui/material";
import { replaceNodesBreadcrumb } from "common/breadcrumb/store";
import React, { useEffect } from "react";
import { useAppDispatch } from "store/hooks";
import { createResource } from "../store";
import CRUDTable from "./crudTable";
import ResourcesToolbar from "./toolbar";
import routes from "developer/routes";

const ResourcesCRUD = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      replaceNodesBreadcrumb([{ text: "Resources", url: routes.RESOURCES }])
    );
  }, [dispatch]);

  const handleFileUpload = (event: React.FormEvent<HTMLInputElement>) => {
    const files = (event.target as HTMLInputElement).files || [];
    if (files?.length) {
      dispatch(createResource(files[0]));
    }
  };

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Box>
        <ResourcesToolbar onFileUpload={handleFileUpload} />
      </Box>
      <Box flexGrow={1} overflow="scroll">
        <Container maxWidth="xl">
          <CRUDTable />
        </Container>
      </Box>
    </Box>
  );
};

export default ResourcesCRUD;
